/**
 * The list of ccTlds (and its variants) that are blocked by U.S. Treasury Department
 */
export const OFAC_TLD_LIST = [
// the Republic of Cuba
'cu',
// the Democratic People's Republic of Korea (North Korea)
'kp',
// the Syrian Arab Republic
'sy', 'xn--ogbpf8fl', 'سورية',
// the Islamic Republic of Iran
'ir', 'xn--mgba3a4f16a', 'ایران'];
//# sourceMappingURL=consts.js.map